document.addEventListener('DOMContentLoaded', () => {
  const section = document.getElementById('shopify-section-template--25348841341273__featured_product_6nab3b');
  if (!section) return;

  const wrapper = section.querySelector('.product__media-wrapper');
  if (!wrapper) return;

  const slides = wrapper.querySelectorAll('.product__media-item');
  if (slides.length < 2) return;

  let current = 0;

  slides.forEach((s, i) => s.style.display = i === 0 ? '' : 'none');

  const prev = document.createElement('button');
  prev.className = 'featured-product-carousel-btn prev';
  prev.innerHTML = '&#8592;';
  prev.setAttribute('aria-label', 'Anterior');

  const next = document.createElement('button');
  next.className = 'featured-product-carousel-btn next';
  next.innerHTML = '&#8594;';
  next.setAttribute('aria-label', 'Siguiente');

  const counter = document.createElement('div');
  counter.className = 'featured-product-carousel-counter';

  const updateUI = () => {
    slides.forEach((s, i) => s.style.display = i === current ? '' : 'none');
    counter.textContent = `${current + 1} de ${slides.length}`;
  };

  prev.addEventListener('click', () => {
    current = (current - 1 + slides.length) % slides.length;
    updateUI();
  });
  next.addEventListener('click', () => {
    current = (current + 1) % slides.length;
    updateUI();
  });

  wrapper.style.position = 'relative';
  wrapper.appendChild(prev);
  wrapper.appendChild(next);
  wrapper.appendChild(counter);
  updateUI();

  const overlay = document.createElement('div');
  overlay.className = 'fp-lightbox-overlay';
  const img = document.createElement('img');
  const closeBtn = document.createElement('button');
  closeBtn.className = 'fp-lightbox-close';
  closeBtn.innerHTML = '&times;';
  overlay.appendChild(img);
  overlay.appendChild(closeBtn);
  document.body.appendChild(overlay);

  slides.forEach(slide => {
    const mediaImg = slide.querySelector('img');
    if (!mediaImg) return;
    slide.style.cursor = 'zoom-in';
    slide.addEventListener('click', () => {
      img.src = mediaImg.src.replace(/width=\d+/, 'width=1200');
      overlay.classList.add('active');
    });
  });

  closeBtn.addEventListener('click', () => overlay.classList.remove('active'));
  overlay.addEventListener('click', e => {
    if (e.target === overlay) overlay.classList.remove('active');
  });
});
